import { render } from "./AoAnForm.vue?vue&type=template&id=c5b6d89e&scoped=true"
import script from "./AoAnForm.vue?vue&type=script&lang=js"
export * from "./AoAnForm.vue?vue&type=script&lang=js"

import "./AoAnForm.vue?vue&type=style&index=0&id=c5b6d89e&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b6d89e"]])

export default __exports__